import { FunctionComponent, useMemo } from 'react'
import { Text } from '@conexasaude/conexa-hero'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { ContentLayout } from './ContentLayout'
import { ContentLayoutProps } from './ContentLayout/types'
import { useStyles } from './styles'
import { AnimateEnter } from '../Animate'

const CustomLayout: FunctionComponent<ContentLayoutProps> = ({
  children,
  ...props
}) => {
  const styles = useStyles()
  const { user } = useAuthContext()
  const patientInfomation = useMemo(() => {
    return `ID: ${user?.patientId} | Clínica: ${user?.clinic?.name}`
  }, [user?.patientId, user?.clinic?.name])

  return (
    <ContentLayout
      layoutFooterProps={{
        timezoneLuxonProps: props.timezoneLuxonProps ?? {
          showSupportLink: false,
        },
        copyContent: user ? (
          <Text variant="microCopy" css={styles.userInfoText}>
            {patientInfomation}
          </Text>
        ) : null,
      }}
      {...props}
    >
      <AnimateEnter>{children}</AnimateEnter>
    </ContentLayout>
  )
}

export default CustomLayout
